module.exports = __webpack_public_path__ + "static/title01-6465b0a50988b01757b04b1f4212e82b.png";